import "./SubNavigation.scss";

import React, { useContext, useEffect, useRef, useState } from "react";

import { Box } from "@mui/material";

import { Media } from "../../shared/contexts/media/MediaContext";
import { UiStateContext } from "../../shared/contexts/ui-state/UiStateContext";
import { FeatureToggle, SubNavigationMenusData } from "../../shared/models/app-data-model";
import SubNavDropdownContent from "./shared/sub-nav-dropdown-content/SubNavDropdownContent";
import SubNavDesktop from "./sub-nav-desktop/SubNavDesktop";
import SubNavMobile from "./sub-nav-mobile/SubNavMobile";
import useFeatureToggle from "../../shared/hooks/use-feature-toggle/useFeatureToggle";

export type SubNavigationProps = {
  subNavigationMenus: SubNavigationMenusData;
  featureToggles: FeatureToggle[];
};

const SubNavigation: React.FC<SubNavigationProps> = ({ subNavigationMenus, featureToggles }) => {
  const uiStateContext = useContext(UiStateContext);
  const isSlfsvc226On = useFeatureToggle('SLFSVC-226', featureToggles);

  const handleClickOutside = (event: any) => {
    if (isSlfsvc226On && event.target && event.target.id.endsWith('overlay')) {
      uiStateContext.setSubNavDropdownOpen?.(false);
      uiStateContext.setSubNavOpenIndex?.(-1);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return (
    <Box className='subnav-container'>
      <Media greaterThanOrEqual="md" className='desktop'>
        <SubNavDesktop subNavigationMenus={subNavigationMenus} featureToggles={featureToggles}/>
        {uiStateContext.subNavDropdownOpen === true && <div id='overlay' className='overlay' data-testid='overlay'>
          <div className='subnav-dropdown-wrapper'><SubNavDropdownContent /></div>
        </div>}
      </Media>
      <Media lessThan='md' className="mobile">
        <SubNavMobile subNavigationMenus={subNavigationMenus} />
      </Media>
    </Box>
  );
};

export default SubNavigation;
